import React, { FC } from "react";
import SchoolsAndStudentsMenu from "./SchoolsAndStudentsMenu";
import OperationServicesMenu from "./OperationServicesMenu";
import PaymentsAndFinanceMenu from "./PaymentsAndFinanceMenu";
import SubcontractorsMenu from "./SubcontractorsMenu";
import NotificationsAndLogsMenu from "./NotificationsAndLogsMenu";
import AdminDataAndToolsMenu from "./AdminDataAndToolsMenu";

interface MenuStructureProps {
  permissions: string[];
}

const MenuStructure: FC<MenuStructureProps> = ({ permissions }) => {
  return (
    <>
      <SchoolsAndStudentsMenu permissions={permissions} />

      <OperationServicesMenu permissions={permissions} />

      <PaymentsAndFinanceMenu permissions={permissions} />

      <SubcontractorsMenu permissions={permissions} />

      <NotificationsAndLogsMenu permissions={permissions} />

      <AdminDataAndToolsMenu permissions={permissions} />
    </>
  );
};

export default MenuStructure;
